import React from 'react';
import { DeviationTypes } from '../../../types/deviation';
import { getDeviationType } from '../../_helpers';
import DefaultThumb from './Default';
import TierThumb from './Tier';
const MobileThumb = (props)=>{
    const type = getDeviationType(props.deviation);
    switch(type){
        case DeviationTypes.TIER:
            return /*#__PURE__*/ React.createElement(TierThumb, props);
        default:
            return /*#__PURE__*/ React.createElement(DefaultThumb, props);
    }
};
MobileThumb.displayName = 'MobileThumb';
export default MobileThumb;
